import React from 'react';
import {
  AccordionsItem,
  AccordionsItemHeader,
  AccordionsItemSection,
  Gutter,
  Paragraph,
  ParagraphHeader,
  ReadonlyTextarea,
  SmallHeader,
} from '@axiom/ui';
import type { UseOnboardingTextReturn } from '@axiom/ui';

import type { Nullable } from '../../types/utility.types';

export type OnboardingWorkScheduleProps = {
  name?: string;
  texts: Nullable<
    Pick<
      NonNullable<ReturnType<UseOnboardingTextReturn['getOnboardingTexts']>>,
      'weeklyCommitment' | 'overtime'
    >
  >;
};

export const EngagementDetailsWorkSchedule = ({
  name,
  texts,
}: OnboardingWorkScheduleProps) => {
  return (
    <AccordionsItem name={name} expanded>
      <AccordionsItemHeader>
        <SmallHeader>Work Schedule</SmallHeader>
      </AccordionsItemHeader>
      {texts.weeklyCommitment ? (
        <AccordionsItemSection>
          <Gutter top="24px" />
          <Paragraph>
            <ReadonlyTextarea
              name="weeklyCommitment"
              value={texts.weeklyCommitment}
              formatting="modern"
            />
          </Paragraph>
          {texts.overtime ? (
            <Gutter top="24px">
              <ParagraphHeader>Overtime:</ParagraphHeader>
              <Gutter bottom="8px" />
              <Paragraph>
                <ReadonlyTextarea
                  name="overtime"
                  value={texts.overtime}
                  formatting="modern"
                />
              </Paragraph>
            </Gutter>
          ) : null}
        </AccordionsItemSection>
      ) : null}
    </AccordionsItem>
  );
};
